/*
 * @Author: chenxiugen@zuoyebang.com
 * @Date: 2021-09-19 09:59:32
 * @LastEditTime: 2022-01-24 10:53:38
 * @LastEditors: 陈秀根
 * @Description: 当前用户用户权限、信息相关
 * 对外提供方法及数据如下：
 * 1、UserOriginData 用户菜单树权限、操作权限、基本信息(内容为响应式数据)
 * 2、requestBaseInfo 请求获取当前登录用户基本信息 -- 路由守卫处调用，其他地方可不用
 * 4、rememberMe 记住密码 -- 登录页使用
 * 5、requestLogin 请求登录
 * 6、requestLogout 请求登出
 * 特别注意： 后端返回的权限列表的authId 前面拼接了menuId 如： authId=10000109是 100001 是menuId ，09是操作权限ID
 * @version2.0 后端提供单独的校验登录接口
 */
import $http from '@/api'
import { RememberKey } from '@/constants'
import CryptoJS from 'crypto-js'

/**
 * 密码验证，只允许6-20数字或字母组合
 */
export const validatePassword = (pwd: string) => {
  return /^[0-9a-z]{6,20}$/i.test(pwd)
}

/**
 * 记住密码
 */
const setRememberMe = (name: string, pwd: string) => {
  const str = JSON.stringify({ name, pwd })
  localStorage.setItem(RememberKey, str)
}
/**
 * 清理记住密码
 */
const clearRememberMe = () => {
  localStorage.removeItem(RememberKey)
}
/**
 * 获取本次存储的用户名称密码
 * @returns {name:string,pwd:string} | null
 */
const getRememberMe = () => {
  const localstr = localStorage.getItem(RememberKey)
  let res = { name: '', pwd: '' }
  if (!localstr) {
    return res
  }
  try {
    res = JSON.parse(localstr)
  } catch (error) {
    // console.error('记住密码获取异常!', error)
  }
  return res
}
// 导出记住密码操作
export const rememberMe = {
  set: setRememberMe,
  get: getRememberMe,
  clear: clearRememberMe
}

/**
 * 请求用户登录
 * @param name 用户名
 * @param pwd 密码
 * @returns res
 * @returns res.errNo 返回errNo, 0 成功 10000001 账号或密码错误  10000002 账号被删除	网络错误等返回-1
//  * @returns res.message getLoginMessageByErrNo
 */
export const requestLogin = async (
  name: string,
  pwd: string
): Promise<Object> => {
  const loginResult = { errNo: -1, msg: '' }
  if (!name || !pwd) {
    return loginResult
  }
  try {
    // 两次md5
    const pwdMD5 = CryptoJS.MD5(
      CryptoJS.MD5(String(pwd)).toString() + 'zybjxyw01001'
    ).toString()
    // 登录接口
    await $http.login(
      {
        loginType: 1, // 1 唯一账号登录 2手机号登录
        account: name,
        password: pwdMD5,
        client: 5 //1.主讲端 2.学校管理后台
      },
      {
        isMessage: false,
        isForm: true
      }
    )
    loginResult.errNo = 0
  } catch (error: any) {
    loginResult.errNo = error.errNo || error.errno || -1
    loginResult.msg = error.errMsg
  }
  return loginResult
}

/**
 * 手机号验证码登录
 * @param param0 手机号、验证码
 * @returns 登录结果
 */
export const requestLoginByPhone = async function ({
  phone,
  smsCode
}: {
  phone: string
  smsCode: string
}) {
  const res = { msg: '', errNo: -1 }
  try {
    await $http.loginByPhone(
      {
        phone: phone,
        smsCode: smsCode,
        client: 5
      },
      {
        isMessage: false
      }
    )
    res.errNo = 0
  } catch (error: any) {
    res.errNo = error.errNo
    res.msg = error.errMsg
  }
  return res
}

/**手机号登录时，获取图形验证码 */
export const getImgCaptcha = async () => {
  try {
    const { data } = await $http.getImgCaptcha()
    return data
  } catch (err) {
    console.log(err)
  }
}
